/**
 * Cart CRO addons: free shipping progress bar + cart cross-sell.
 * Self-contained, decoupled from cart-drawer.js's getSectionsToRender()
 * allow-list — refreshes itself off /cart.js plus a lightweight fetch
 * patch that broadcasts every cart mutation (add/change/update/clear),
 * so it works no matter which component or app triggered the change.
 */
(function () {
  if (window.__cartCroAddonsPatched) return;
  window.__cartCroAddonsPatched = true;

  var origFetch = window.fetch;
  window.fetch = function () {
    var target = arguments[0];
    var urlStr = typeof target === 'string' ? target : (target && target.url) || '';
    var isCartMutation = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(urlStr);
    var p = origFetch.apply(this, arguments);
    if (isCartMutation) {
      p.then(function (res) {
        if (res && res.ok) {
          document.dispatchEvent(new CustomEvent('cart:cro-refresh'));
        }
        return res;
      }).catch(function () {});
    }
    return p;
  };

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  function formatMoney(cents, currency) {
    var amount = (cents || 0) / 100;
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'USD' }).format(amount);
    } catch (e) {
      return '$' + amount.toFixed(2);
    }
  }

  function defineFreeShippingBar() {
    if (customElements.get('free-shipping-bar')) return;

    class FreeShippingBarEl extends HTMLElement {
      connectedCallback() {
        this.threshold = parseInt(this.dataset.thresholdCents || '10000', 10);
        this.progressTpl = this.dataset.progressTemplate || "You're [amount] away from FREE shipping!";
        this.successText = this.dataset.successText || "You've unlocked FREE shipping!";
        this.msgEl = this.querySelector('[data-fsb-message]');
        this.fillEl = this.querySelector('[data-fsb-fill]');
        this._onRefresh = this.refresh.bind(this);
        document.addEventListener('cart:cro-refresh', this._onRefresh);
        document.addEventListener('cart:updated', this._onRefresh);
        this.refresh();
      }
      disconnectedCallback() {
        document.removeEventListener('cart:cro-refresh', this._onRefresh);
        document.removeEventListener('cart:updated', this._onRefresh);
      }
      refresh() {
        var self = this;
        fetchCart()
          .then(function (cart) {
            self.render(cart);
          })
          .catch(function () {});
      }
      render(cart) {
        var total = cart.total_price || 0;
        var currency = (cart.currency || 'USD').toUpperCase();
        var pct = Math.max(0, Math.min(100, Math.round((total / this.threshold) * 100)));
        if (this.fillEl) this.fillEl.style.width = pct + '%';
        if (!this.msgEl) return;
        if (total >= this.threshold) {
          this.msgEl.textContent = this.successText;
          this.classList.add('is-complete');
        } else {
          var remaining = this.threshold - total;
          this.msgEl.textContent = this.progressTpl.replace('[amount]', formatMoney(remaining, currency));
          this.classList.remove('is-complete');
        }
      }
    }

    customElements.define('free-shipping-bar', FreeShippingBarEl);
  }

  function defineCartCrossSell() {
    if (customElements.get('cart-cross-sell')) return;

    class CartCrossSellEl extends HTMLElement {
      connectedCallback() {
        this.baseUrl = this.dataset.baseUrl;
        this.limit = this.dataset.limit || 4;
        this.listEl = this.querySelector('[data-cart-cross-sell-list]');
        this.wrapper = this.closest('[data-cart-cross-sell-wrapper]');
        this._onRefresh = this.refresh.bind(this);
        document.addEventListener('cart:cro-refresh', this._onRefresh);
        document.addEventListener('cart:updated', this._onRefresh);
        this.refresh();
      }
      disconnectedCallback() {
        document.removeEventListener('cart:cro-refresh', this._onRefresh);
        document.removeEventListener('cart:updated', this._onRefresh);
      }
      refresh() {
        var self = this;
        fetchCart()
          .then(function (cart) {
            if (!cart.items || cart.items.length === 0) {
              if (self.wrapper) self.wrapper.style.display = 'none';
              self._lastProductId = null;
              return;
            }
            var productId = cart.items[cart.items.length - 1].product_id;
            if (self._lastProductId === productId && self._loaded) return;
            self._lastProductId = productId;
            var url =
              self.baseUrl +
              '?section_id=' +
              encodeURIComponent(self.dataset.sectionId) +
              '&product_id=' +
              encodeURIComponent(productId) +
              '&limit=' +
              encodeURIComponent(self.limit) +
              '&intent=complementary';
            fetch(url)
              .then(function (r) {
                return r.text();
              })
              .then(function (html) {
                var doc = new DOMParser().parseFromString(html, 'text/html');
                var newList = doc.querySelector('[data-cart-cross-sell-list]');
                if (newList && newList.children.length > 0) {
                  self.listEl.innerHTML = newList.innerHTML;
                  if (self.wrapper) self.wrapper.style.display = '';
                  self._loaded = true;
                } else if (self.wrapper) {
                  self.wrapper.style.display = 'none';
                  self._loaded = false;
                }
              })
              .catch(function () {});
          })
          .catch(function () {});
      }
    }

    customElements.define('cart-cross-sell', CartCrossSellEl);
  }

  defineFreeShippingBar();
  defineCartCrossSell();
})();
